module.exports = __webpack_public_path__ + "img/stethoscope.b422e51f.svg";